export default function Hero() {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ece2f928e68c320c86917b35ccea8092.jpg"
          alt="Professional Electrician"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-28 md:pt-32 md:pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-0">
          {/* Lado Izquierdo - Imagen con Overlay */}
          <div className="relative rounded-3xl overflow-hidden min-h-[320px] md:min-h-[500px] lg:min-h-[560px]">
            <img
              src="https://readdy.ai/api/search-image?query=professional%20electrician%20working%20on%20electrical%20panel%20in%20modern%20building%2C%20expert%20technician%20with%20tools%20installing%20wiring%20in%20contemporary%20interior%2C%20dramatic%20dark%20industrial%20atmosphere%20with%20focused%20yellow%20work%20lighting%2C%20ultra%20detailed%20photography%2C%20high%20contrast%20moody%20scene%20with%20sparks%20and%20electricity&width=800&height=1000&seq=hero-elec-main&orientation=portrait"
              alt="Electricista profesional trabajando"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black via-black/65 to-black/40"></div>

            {/* Contenido sobre la imagen */}
            <div className="relative z-10 h-full flex flex-col justify-center px-6 md:px-12 py-10 md:py-16">
              <div className="mb-4 md:mb-8">
                <span className="inline-block bg-[#FFD700]/20 border border-[#FFD700] text-[#FFD700] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-light tracking-wide">
                  Electricistas Certificados · Asesoramiento Personalizado
                </span>
              </div>

              <div className="mb-6 md:mb-12">
                <h1 className="text-white font-bold text-4xl sm:text-5xl md:text-7xl leading-none" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  EXPERTOS
                </h1>
                <h1 className="text-[#FFD700] font-extrabold text-5xl sm:text-6xl md:text-8xl leading-none" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  ELÉCTRICOS
                </h1>
                <h1 className="text-gray-200 font-bold text-3xl sm:text-4xl md:text-6xl leading-none" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  A TU SERVICIO
                </h1>
              </div>

              {/* Icono decorativo flotante */}
              <div className="absolute top-4 md:top-8 right-4 md:right-8 w-12 h-12 md:w-20 md:h-20 flex items-center justify-center">
                <div className="relative animate-pulse">
                  <i className="ri-flashlight-line text-[#FFD700] text-3xl md:text-5xl"></i>
                  <div className="absolute inset-0 bg-[#FFD700]/20 rounded-full blur-xl"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Lado Derecho - Contenido */}
          <div className="bg-[#1E1E1E] rounded-3xl flex flex-col justify-center px-6 md:px-12 py-10 md:py-16 relative overflow-hidden">
            <div className="absolute inset-0 opacity-5" style={{
              backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 35px, #FFD700 35px, #FFD700 36px), repeating-linear-gradient(60deg, transparent, transparent 35px, #FFD700 35px, #FFD700 36px), repeating-linear-gradient(120deg, transparent, transparent 35px, #FFD700 35px, #FFD700 36px)'
            }}></div>

            <div className="relative z-10">
              <h2 className="text-white font-semibold text-xl md:text-4xl mb-4 md:mb-6 leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Instalaciones eléctricas, asesoramiento experto e iluminación LED a medida
              </h2>

              <p className="text-gray-400 text-sm md:text-lg leading-relaxed mb-6 md:mb-10" style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.8' }}>
                Desde reparaciones urgentes hasta proyectos completos de iluminación interior con tiras LED. Te asesoramos en cada paso para que tu hogar o negocio funcione con seguridad, eficiencia y estilo.
              </p>

              {/* Puntos clave */}
              <ul className="space-y-2.5 md:space-y-3 mb-6 md:mb-12">
                {[
                  { icon: 'ri-shield-check-line', text: 'Instalaciones certificadas y seguras' },
                  { icon: 'ri-lightbulb-line', text: 'Diseño de iluminación LED personalizado' },
                  { icon: 'ri-customer-service-2-line', text: 'Asesoramiento gratuito sin compromiso' },
                ].map((item) => (
                  <li key={item.text} className="flex items-center gap-3">
                    <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-[#FFD700] text-base md:text-lg`}></i>
                    </div>
                    <span className="text-gray-300 text-sm md:text-base" style={{ fontFamily: 'Inter, sans-serif' }}>{item.text}</span>
                  </li>
                ))}
              </ul>

              <div className="flex flex-col gap-3 md:gap-4">
                <a
                  href="#contacto"
                  className="bg-[#FFD700] text-black px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold text-sm md:text-base hover:bg-[#FFC700] hover:shadow-2xl hover:shadow-[#FFD700]/50 transition-all duration-300 hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
                >
                  <span>Presupuesto en 24h</span>
                  <i className="ri-flashlight-line text-lg md:text-xl"></i>
                </a>

                <a
                  href="https://wa.me/34633518361"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border-2 border-[#FFD700] text-[#FFD700] bg-transparent px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold text-sm md:text-base hover:bg-[#FFD700]/10 hover:shadow-lg hover:shadow-[#FFD700]/30 transition-all duration-300 hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
                >
                  <span>Urgencias WhatsApp</span>
                  <i className="ri-whatsapp-line text-lg md:text-xl"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Stats Bar */}
      <div className="absolute bottom-0 left-0 right-0 z-10 bg-gradient-to-r from-[#003366] to-[#004488] py-4 md:py-8">
        <div className="max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 text-center">
          {[
            { value: '7+', label: 'Años de experiencia' },
            { value: '754+', label: 'Proyectos completados' },
            { value: '98%', label: 'Clientes satisfechos' },
            { value: '24/7', label: 'Servicio de urgencias' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-[#FFD700] font-extrabold text-2xl md:text-4xl" style={{ fontFamily: 'Poppins, sans-serif' }}>{stat.value}</div>
              <div className="text-white/70 text-xs md:text-sm mt-1" style={{ fontFamily: 'Inter, sans-serif' }}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
